import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PageEditor from "../components/PageEditor";

const PageEditorPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='New Page Add' />

                <PageEditor />

            </MasterLayout>
        </>
    );
};

export default PageEditorPage;
